import React, { useEffect, useState } from 'react';
import { Pencil, Trash, Plus, Search, Mail, Phone, FileText } from 'lucide-react';
import { useAdmin } from '../AdminLayout/AdminProvider';
import axios from 'axios';


const API_BASE = "https://api.propertygalleria.in/master/api";

const PropertyOwnerMaster = () => {
  const { propertyOwners, projects, addPropertyOwner, updatePropertyOwner, deletePropertyOwner,fetchPropertyOwners } = useAdmin();
const [ownersData, setOwnersData] = useState([]);
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [editingOwner, setEditingOwner] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [aadharOtpSent, setAadharOtpSent] = useState(false);
  const [aadharOtp, setAadharOtp] = useState("");
  const [aadharVerified, setAadharVerified] = useState(false);
  const [gstVerified, setGstVerified] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);

  const [formData, setFormData] = useState({
    companyName: '',
    ownerName: '',
    mobile: '',
    email: '',
    projectId: '',
    aadharKyc: '',
    gstKyc: '',
  });


  const sendAadharOtp = async () => {
    if (formData.aadharKyc.length !== 12) {
      alert("Enter valid 12-digit Aadhaar number");
      return;
    }

    try {
      setLoadingOtp(true);
      await axios.post(`${API_BASE}/api/send-aadhar-otp`, {
        Aadhar_No: formData.aadharKyc,
      });
      setAadharOtpSent(true);
      alert("OTP sent successfully");
    } catch {
      alert("Failed to send OTP");
    } finally {
      setLoadingOtp(false);
    }
  };

  const verifyAadharOtp = async () => {
    if (!aadharOtp) {
      alert("Enter OTP");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/verify-aadhar-otp`, {
        otp: aadharOtp,
        Aadhar_No: formData.aadharKyc,
      });

      setAadharVerified(true);
      alert("Aadhaar verified successfully");
    } catch {
      alert("OTP verification failed");
    }
  };


  const verifyGst = async () => {
    if (!formData.gstKyc) {
      alert("Enter GST number");
      console.log("❌ No GST number entered");
      return;
    }

    try {
      // Call GST verification API
      const res = await axios.post(`${API_BASE}/verify-gst`, {
        GST: formData.gstKyc,
      });

      console.log("API response:", res.data);

      // Correctly access fields directly from res.data
      const businessName =
        res.data?.trade_name_of_business ||
        res.data?.legal_name_of_business ||
        "";

      if (!businessName) {
        console.log("❌ GST verification failed: API returned empty company name");
        alert("GST verification failed: no business name returned from API");
        setGstVerified(false);
        return;
      }

      // Normalize strings: remove extra spaces and lowercase
      const enteredCompany = formData.companyName.trim().toLowerCase();
      const gstCompany = businessName.trim().toLowerCase();

      console.log("Entered Company:", enteredCompany);
      console.log("GST Company:", gstCompany);

      // Check if the names match closely
      if (gstCompany.includes(enteredCompany) || enteredCompany.includes(gstCompany)) {
        console.log("✅ GST verified successfully");
        setGstVerified(true);
        alert("GST verified successfully");
      } else {
        console.log(
          `❌ GST verification failed: GST business name "${businessName}" does not match Company Name "${formData.companyName}"`
        );
        setGstVerified(false);
        alert(`GST business name "${businessName}" does not match Company Name "${formData.companyName}"`);
      }
    } catch (err) {
      console.error("❌ GST verification error:", err);
      setGstVerified(false);
      alert("GST verification failed due to API error");
    }
  };



  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.ownerName || !formData.mobile || !formData.email || !formData.aadharKyc) {
      alert("Please fill all required fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      alert("Please enter a valid email address");
      return;
    }

    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      alert("Please enter a valid 10-digit mobile number");
      return;
    }

    const ownerData = {
      full_name: formData.ownerName,
      email: formData.email,
      mobile_number: formData.mobile,
      aadhaar_number: formData.aadharKyc,
      owner_type: formData.companyName ? "company" : "individual",
      address: formData.address || "NA",
      company_name: formData.companyName || null,
      gst_number: formData.gstKyc || null,
  project_name: formData.projectId, 
      aadhaar_verified: "1"
    };

    if (editingOwner) {
      console.log('tis i editingOwner',editingOwner)
      console.log('this is editingOwner',editingOwner.id)
      updatePropertyOwner(editingOwner.user_id, ownerData);
    } else {
      addPropertyOwner(ownerData);
      setGstVerified(false);
    }

    resetForm();
  };


  const resetForm = () => {
    setFormData({
      companyName: '',
      ownerName: '',
      mobile: '',
      email: '',
      projectId: '',
      aadharKyc: null,
      gstKyc: null,
    });
    setEditingOwner(null);
    setIsFormOpen(false);
  };

  const handleEdit1 = (owner) => {
    const project = projects.find(
      (p) => p.project_name === owner.project_name
    );
    setEditingOwner(owner);
    setFormData({
      companyName: owner.company_name,
      ownerName: owner.owner_name,
      mobile: owner.mobile,
      email: owner.email,
      projectId: project ? project.id : "",
      aadharKyc: owner.aadhar_no || "", // populate Aadhaar number
      gstKyc: owner.gst_no || "",       // populate GST number
    });
    setIsFormOpen(true);
  };


  const handleEdit11 = (owner) => {
  const project = projects.find(
    (p) => p.project_name === owner.project_name
  );

  setEditingOwner(owner);

  setFormData({
    companyName: owner.company_name || "",
    ownerName: owner.full_name || "",
    mobile: owner.mobile_number || "",
    email: owner.email || "",
    projectId: project ? project.id : "",
    address: owner.address || "",
    aadharKyc: owner.aadhaar_number || "",
    gstKyc: owner.gst_number || "",
  });

  setIsFormOpen(true);
};





const handleEdit123 = (owner) => {
  // match project by name
  const project = projects.find(
    (p) => p.project_name === owner.project_name
  );

  setEditingOwner(owner);

  setFormData({
    companyName: owner.company_name || "",
    ownerName: owner.full_name || "",
    mobile: owner.mobile_number || "",
    email: owner.email || "",
    projectId: project ? String(project.id) : "",
    address: owner.address || "",
    aadharKyc: owner.aadhaar_number || "",
    gstKyc: owner.gst_number || "",
  });

  setIsFormOpen(true);
};

const handleEdit = (owner) => {
  const project = projects.find(
    (p) =>
      p.project_name?.trim().toLowerCase() ===
      owner.project_name?.trim().toLowerCase()
  );

  setEditingOwner(owner);

  setFormData({
    companyName: owner.company_name || "",
    ownerName: owner.full_name || "",
    mobile: owner.mobile_number || "",
    email: owner.email || "",
    projectId: project ? String(project.id) : "",
    address: owner.address || "",
    aadharKyc: owner.aadhaar_number || "",
    gstKyc: owner.gst_number || "",
  });

  setIsFormOpen(true);
};



  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this property owner?')) {
      deletePropertyOwner(id);
      alert('Property Owner deleted successfully');
    }
  };

  const handleFileChange = (e) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      if (e.target.name === 'aadharKyc') {
        setFormData({ ...formData, aadharKyc: files[0] });
      } else if (e.target.name === 'gstKyc') {
        setFormData({ ...formData, gstKyc: files[0] });
      }
    }
  };

  // console.log('this is propertyOwners', propertyOwners)
  // const filteredOwners = propertyOwners.filter(
  //   (owner) =>
  //     owner.company_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     owner.full_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     owner.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     owner.mobile_number.includes(searchTerm)
  // );
  const filteredOwners = propertyOwners.filter((owner) => {
    const search = searchTerm.toLowerCase();

    return (
      (owner.company_name ?? "").toLowerCase().includes(search) ||
      (owner.full_name ?? "").toLowerCase().includes(search) ||
      (owner.email ?? "").toLowerCase().includes(search) ||
      (owner.mobile_number ?? "").includes(searchTerm)
    );
  });


  const getProjectName = (projectId) => {
    const id = Number(projectId); // convert string to number
    const project = projects.find((p) => p.id === id);
    return project ? project.project_name : projectId;
  };


  const styles = {
    container: { padding: '24px', fontFamily: 'Arial, sans-serif' },
    header: { marginBottom: '24px' },
    title: { fontSize: '24px', fontWeight: 'bold', color: '#0B1C3D', marginBottom: '4px' },
    subtitle: { color: '#666' },
    actionsBar: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', gap: '16px' },
    searchWrapper: { position: 'relative', flex: 1, maxWidth: '400px' },
    searchIcon: { position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#999' },
    searchInput: { width: '100%', padding: '8px 12px 8px 32px', border: '1px solid #ccc', borderRadius: '8px', outline: 'none' },
    button: { display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#8b306d', color: '#fff', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', border: 'none' },
    formContainer: { backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '8px', padding: '24px', marginBottom: '24px', boxShadow: '0 1px 4px rgba(0,0,0,0.1)' },
    formTitle: { fontSize: '20px', fontWeight: 600, marginBottom: '16px', color: '#0B1C3D' },
    label: { display: 'block', fontSize: '14px', fontWeight: 500, marginBottom: '4px', color: '#333', textAlign: 'left' },
    input: { width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '8px', marginBottom: '12px', outline: 'none' },
    select: { width: '100%', padding: '8px 12px', border: '1px solid #ccc', borderRadius: '8px', marginBottom: '12px', outline: 'none' },
    fileInfo: { fontSize: '12px', color: 'green', marginTop: '4px' },
    submitButton: { backgroundColor: '#8b306d', color: '#fff', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer', marginRight: '8px' },
    cancelButton: { backgroundColor: '#ccc', color: '#333', padding: '8px 16px', borderRadius: '8px', border: 'none', cursor: 'pointer' },
    tableContainer: { backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '8px', overflowX: 'auto', marginBottom: '16px' },
    table: { width: '100%', borderCollapse: 'collapse' },
    th: { padding: '12px', textAlign: 'left', backgroundColor: '#8b306d', color: '#fff', textAlign: 'center' },
    td: { padding: '12px', borderBottom: '1px solid #ddd', verticalAlign: 'middle' },
    actionButton: { padding: '4px', borderRadius: '6px', cursor: 'pointer', border: 'none', marginLeft: '4px' },
    badge: { display: 'inline-flex', padding: '4px 8px', borderRadius: '12px', backgroundColor: '#42987e', color: '#fff', fontWeight: 600 },
    stats: { marginTop: '16px', fontSize: '14px', color: '#666' },
  };



    const [checkedUsers, setCheckedUsers] = useState([]);
  
    const toggleCheckbox = (userId) => {
      setCheckedUsers((prev) => {
        if (prev.includes(userId)) {
          return prev.filter((id) => id !== userId);
        } else {
          return [...prev, userId];
        }
      });
    };


useEffect(() => {
  setOwnersData(filteredOwners);
}, []);


  
    const handleSubmitApprove = async () => {
      try {
        // Approve all selected users
        await Promise.all(
          checkedUsers.map((userId) =>
            axios.put(`https://api.propertygalleria.in/master/api/approve/${userId}`)
          )
        );
  
        alert("Selected users approved successfully!");
  
        
        setCheckedUsers([]);
        fetchPropertyOwners();
        // setOwnersData(filteredOwners);
        // Optional: refresh list here
      } catch (error) {
        console.error(error);
        alert("Approval failed. Please try again.");
      }
    };
  

        // pagenation

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        setCurrentPage(1);
    }, [searchTerm]);

    const totalPages = Math.ceil(filteredOwners.length / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedLeads = filteredOwners.slice(
        startIndex,
        startIndex + itemsPerPage
    );
console.log('this is paginatedLeads',paginatedLeads)

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.title}>Property Owner Master</h1>
        <p style={styles.subtitle}>Manage property owners and their project allocations</p>
      </div>

      <div style={styles.actionsBar}>
        <div style={styles.searchWrapper}>
          <Search size={20} style={styles.searchIcon} />
          <input
            type="text"
            placeholder="Search property owners..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.searchInput}
          />
        </div>
        <button style={styles.button} onClick={() => {
          setIsFormOpen(true);
          setGstVerified(false);
        }}
        >
          <Plus size={20} /> Add Property Owner
        </button>
      </div>

      {isFormOpen && (
        <div style={styles.formContainer}>
          <h2 style={styles.formTitle}>{editingOwner ? 'Edit Property Owner' : 'Create New Property Owner'}</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(240px,1fr))', gap: '16px' }}>

              <div>
                <label style={{ display: 'block', textAlign: 'left', marginBottom: 4, fontSize: 14, fontWeight: 500, color: '#333' }}>Property Allocation *</label>
                <select
                  value={formData.projectId}
                  onChange={(e) => setFormData({ ...formData, projectId: e.target.value })}
                  style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', outline: 'none' }}
                  required
                >
                  <option value="">Select Property</option>
                  {projects.map((project) => (
                    <option key={project.id} value={project.id}>
                      {project.title} - {project.location}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label style={styles.label}>Company/Personal Name *</label>
                <input
                  type="text"
                  value={formData.companyName}
                  onChange={(e) => setFormData({ ...formData, companyName: e.target.value })}
                  placeholder="e.g., ABC Realty Pvt Ltd"
                  style={styles.input}
                  required
                />
              </div>
              <div>
                <label style={styles.label}>Owner Name *</label>
                <input
                  type="text"
                  value={formData.ownerName}
                  onChange={(e) => setFormData({ ...formData, ownerName: e.target.value })}
                  placeholder="e.g., Rajesh Kumar"
                  style={styles.input}
                  required
                />
              </div>
              <div>
                <label style={styles.label}>Address *</label>
                <input
                  type="text"
                  value={formData.address}
                  onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  placeholder="Enter your Address"
                  style={styles.input}
                  required
                />
              </div>
              <div>
                <label style={styles.label}>Mobile Number *</label>
                <input
                  type="tel"
                  value={formData.mobile}
                  onChange={(e) => setFormData({ ...formData, mobile: e.target.value.replace(/\D/g, '').slice(0, 10) })}
                  placeholder="6309824545"
                  style={styles.input}
                  required
                />
              </div>
              <div>
                <label style={styles.label}>Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  placeholder="email@gmail.com"
                  style={styles.input}
                  required
                />
              </div>


              <div>
                <label style={styles.label}>Aadhaar Number *</label>
                <input
                  type="text"
                  value={formData.aadharKyc}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      aadharKyc: e.target.value.replace(/\D/g, "").slice(0, 12),
                    })
                  }
                  placeholder="12-digit Aadhaar"
                  style={styles.input}
                />

                <button type="button" onClick={sendAadharOtp} disabled={aadharOtpSent}>
                  {loadingOtp ? "Sending..." : "Send OTP"}
                </button>

                {aadharVerified && (
                  <span style={{ marginLeft: 8, color: "green" }}>✔ Verified</span>
                )}
              </div>

              {aadharOtpSent && !aadharVerified && (
                <div>
                  <input
                    type="text"
                    value={aadharOtp}
                    onChange={(e) => setAadharOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                    placeholder="Enter OTP"
                    style={styles.input}
                  />
                  <button type="button" onClick={verifyAadharOtp}>
                    Verify OTP
                  </button>
                </div>
              )}

              <div>
                <label style={styles.label}>GST Number</label>
                <input
                  type="text"
                  value={formData.gstKyc}
                  onChange={(e) =>
                    setFormData({ ...formData, gstKyc: e.target.value.toUpperCase() })
                  }
                  placeholder="GSTIN"
                  style={styles.input}
                />

                <button type="button" onClick={verifyGst}>
                  Verify GST
                </button>

                {gstVerified && (
                  <span style={{ marginLeft: 8, color: "green" }}>✔ Verified</span>
                )}
              </div>

            </div>
            <div style={{ marginTop: '16px' }}>
              <button type="submit" style={styles.submitButton}>
                {editingOwner ? 'Update Property Owner' : 'Create Property Owner'}
              </button>
              <button type="button" onClick={resetForm} style={styles.cancelButton}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.tableContainer}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>Company/Personal Name</th>
              <th style={styles.th}>Owner Name</th>
              <th style={styles.th}>Mobile</th>
              <th style={styles.th}>Email</th>
              <th style={styles.th}>Project Assigned</th>
              <th style={styles.th}>Aadhar</th>
              <th style={styles.th}>GST</th>
              <th style={styles.th}>Actions</th>
              <th style={styles.th}>Approve </th>
            </tr>
          </thead>
          <tbody>
            {paginatedLeads.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ padding: '24px', textAlign: 'center', color: '#666' }}>
                  {searchTerm
                    ? 'No property owners found matching your search'
                    : 'No property owners created yet. Click "Add Property Owner" to get started.'}
                </td>
              </tr>
            ) : (
              paginatedLeads.map((owner, index) => (
                <tr key={`${owner.id}-${owner.user_id}`} style={{ backgroundColor: index % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                  <td style={styles.td}>{owner.company_name}</td>
                  <td style={styles.td}>{owner.full_name}</td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Phone size={16} color="#999" /> {owner.mobile_number}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <Mail size={16} color="#999" /> {owner.email}
                    </div>
                  </td>
                  <td style={styles.td}>
                    <span style={styles.badge}>{getProjectName(owner.project_name)}</span>
                  </td>
                  <td style={styles.td}>
                    {owner.aadhaar_number ? <FileText size={20} color="green" /> : <span style={{ color: '#999', fontSize: '12px' }}>N/A</span>}
                  </td>
                  <td style={styles.td}>
                    {owner.gst_number ? <FileText size={20} color="green" /> : <span style={{ color: '#999', fontSize: '12px' }}>N/A</span>}
                  </td>
                  <td style={styles.td}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                      <button onClick={() => handleEdit(owner)} style={{ ...styles.actionButton, color: '#8b306d' }} title="Edit">
                        <Pencil size={18} />
                      </button>
                      <button onClick={() => handleDelete(owner.user_id)} style={{ ...styles.actionButton, color: '#42987e' }} title="Delete">
                        <Trash size={18} />
                      </button>
                    </div>
                  </td>

                    {/* <td style={styles.td}>{associate.is_admin_approve}</td> */}
                  <td style={styles.td}>
                    <input
                      type="checkbox"
                      checked={
                        owner.is_admin_approve === 1
                          ? true
                          : checkedUsers.includes(owner.user_id)
                      }
                     // disabled={associate.is_admin_approve === 1}
                      onChange={() => toggleCheckbox(owner.user_id)}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
           {/* ✅ Show Submit Button only if at least 1 checked */}
        {checkedUsers.length > 0 && (
          <div style={{ marginTop: "16px", textAlign: "right" }}>
            <button onClick={handleSubmitApprove} style={styles.submitButton}>
              Approve the User
            </button>
          </div>
        )}
      </div>

      <div style={styles.stats}>
        Total Property Owners: {filteredOwners.length}
        {searchTerm && ` (filtered from ${propertyOwners.length})`}
      </div>


      
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "12px 16px",
                    borderTop: "1px solid #E5E7EB",
                    background: "#F9FAFB",
                }}
            >
                <div style={{ fontSize: 14, color: "#6B7280" }}>
                    Showing {startIndex + 1}–
                    {Math.min(startIndex + itemsPerPage, filteredOwners.length)} of{" "}
                    {filteredOwners.length}
                </div>

                <div style={{ display: "flex", gap: "6px" }}>
                    <button
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage((p) => p - 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                            background: currentPage === 1 ? "#eee" : "#fff",
                            cursor: "pointer",
                        }}
                    >
                        Prev
                    </button>

                    {Array.from({ length: totalPages }, (_, i) => i + 1)
                        .slice(
                            Math.max(0, currentPage - 3),
                            Math.min(totalPages, currentPage + 2)
                        )
                        .map((page) => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                style={{
                                    padding: "6px 12px",
                                    borderRadius: "6px",
                                    border: "1px solid #ddd",
                                    background:
                                        currentPage === page ? "#8b306d" : "#fff",
                                    color: currentPage === page ? "#fff" : "#333",
                                    cursor: "pointer",
                                }}
                            >
                                {page}
                            </button>
                        ))}

                    <button
                        disabled={currentPage === totalPages}
                        onClick={() => setCurrentPage((p) => p + 1)}
                        style={{
                            padding: "6px 12px",
                            borderRadius: "6px",
                            border: "1px solid #ddd",
                            background:
                                currentPage === totalPages ? "#eee" : "#fff",
                            cursor: "pointer",
                        }}
                    >
                        Next
                    </button>
                </div>
            </div>

    </div>
  );
};

export default PropertyOwnerMaster;
